export const CRUD_READ_PENDING = 'CRUD_CITIES_READ_PENDING'
export const CRUD_READ_SUCCEEDED = 'CRUD_CITIES_READ_SUCCEEDED'
export const CRUD_READ_FAILED = 'CRUD_CITIES_READ_FAILED'
